import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiService } from 'src/app/services/api/api.service';
import { ModalService } from '../modal.service';
import { CoreTranslateService } from 'src/app/services/utilitys/utilitys.service';

@Component({
  selector: 'app-modal-market-rating',
  templateUrl: './modal-market-rating.component.html',
  styleUrls: ['./modal-market-rating.component.scss']
})
export class ModalMarketRatingComponent implements OnInit {

  @ViewChild('marketRatingModal', {static: false}) modal;
  modalRef: BsModalRef;
  configmodal = {
    class: 'modal-dialog-centered modal-sm', 
    ignoreBackdropClick: true, 
    keyboard: false,
    animated: false
  };
  currentScore = 0;
  product: any = {};
  errorMsg = '';
  callback: Function;
  isShow = false;

  constructor(
    private modalServ: ModalService,
    private modalService: BsModalService,
    private api: ApiService,
    private ngxLoading: NgxUiLoaderService,
    private coreTranslate: CoreTranslateService
  ) { }

  ngOnInit() {
    this.modalServ.onMarketRating.subscribe(req => {
      this.product = req.product;
      this.product.ProductID = this.product.ProductID ? this.product.ProductID : this.product.ProductId;
      this.callback = req.callback;
      this.errorMsg = '';
      if(!this.isShow) {this.show();}
    });

    this.modalServ.onMarketRatingHide.subscribe(req => {
      this.hide();
    });
  }

  show() {
    if(this.modalRef){
      this.modalRef.hide();
    }
    this.isShow = true;
    this.modalRef = this.modalService.show(this.modal, this.configmodal);
  }

  hide() {
    if(this.modalRef){
      this.modalRef.hide();
      this.isShow = false;
    }
  }

  confirm(): void {
    this.ratingProduct();
  }

  onRatingClick(item: any) {
    this.currentScore = item;
  }

  ratingProduct() {
    if(!this.product.ProductID) {
      this.errorMsg = this.coreTranslate.getWord('PRODUCT.PRODUCT_NOT_FOUND_PLEASE_TRY_AGAIN');
      return false;
    }

    if(this.currentScore == 0) {
      this.errorMsg = this.coreTranslate.getWord('PRODUCT.PLEASE_RATE_IT');
      return false;
    }

    this.ngxLoading.start();
    this.api.marketPlaceRatingProduct({
      ProductId: this.product.ProductID,
      Rating: this.currentScore
    }).subscribe(async(res) => {
      if (res.Code == 200) {
        this.callback({status: 'success'});
      } else {
        this.callback({status: 'fail', massage: res.Message});
      }
      this.hide();
      this.ngxLoading.stopAll();
    }, err => {
      console.error(err);
      this.callback({status: 'fail', massage: 'Internal Error.'});
      this.hide();
      this.ngxLoading.stopAll();
    });
  }
  
}
